<template>
  <div class="d-flex flex-column" style="gap: 5px;">
    <div class="d-flex align-center justify-space-between">
      <span class="text-caption text-uppercase font-weight-medium grey--text">
        {{ label }}
      </span>
      <v-chip color="#f1f1f1" small rounded dense>
        {{ displayValue }}{{ unit ? "\u00a0" + unit : "" }}
      </v-chip>
    </div>
    <v-slider
      :value="sliderValue"
      :min="sliderMin"
      :max="sliderMax"
      :step="step"
      :color="color"
      track-color="grey lighten-2"
      hide-details
      @input="onInput"
    />
    <div class="d-flex justify-space-between" style="margin-top: -4px;">
      <span class="text-caption grey--text" style="font-size: 9px;">
        {{ Math.abs(sliderMin) }}{{ unit ? "\u00a0" + unit : "" }}
      </span>
      <span class="text-caption grey--text" style="font-size: 9px;">
        {{ Math.abs(sliderMax) }}{{ unit ? "\u00a0" + unit : "" }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "a-pricing-strategy-rule-type-condition-field-slider",
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
    label: { type: String, default: "" },
    unit: { type: String, default: "" },
    color: { type: String, default: "secondary" },
    // Rangos negativos (p.ej. -25..-1): pinta el slider en valor absoluto
    // (1..25, pequeño a la izquierda) y emite el valor negado.
    invert: { type: Boolean, default: false }
  },
  computed: {
    displayValue() {
      return Math.abs(this.value);
    },
    sliderMin() {
      return this.invert ? -this.max : this.min;
    },
    sliderMax() {
      return this.invert ? -this.min : this.max;
    },
    sliderValue() {
      return this.invert ? -this.value : this.value;
    }
  },
  methods: {
    onInput(v) {
      this.$emit("input", this.invert ? -v : v);
    }
  }
};
</script>
